function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { IntlProvider, injectIntl } from "react-intl";
import { AppContext } from "../providers/Context";
import { AppContextProvider } from "../../dist";
class EmbeddedGateway extends React.Component {
  constructor(props) {
    super(props);
    this.renderEmbeddedComponents = this.renderEmbeddedComponents.bind(this);
    this.wrapper = /*#__PURE__*/React.createRef();
  }
  renderEmbeddedComponents() {
    const {
      locale,
      store,
      getComponent
    } = this.props;
    const node = ReactDOM.findDOMNode(this);
    //const elements = node.getElementsByClassName("viz-component")

    const elements = node.querySelectorAll(".viz-component:not(.self-render-component > .viz-component)");
    if (!(elements == null)) {
      Array.from(elements).forEach((element, index) => {
        let container = element;
        const component = element.getAttribute('data-component');
        element.removeAttribute("data-component");
        if (element.nodeName !== "DIV") {
          const div = document.createElement("div");
          element.replaceWith(div);
          div.setAttribute("class", element.getAttribute("class"));
          div.setAttribute("id", "generated_div");
          element.getAttributeNames().forEach(a => {
            div.setAttribute(a, element.getAttribute(a));
          });
          container = div;
        }
        if (component) {
          const props = {
            ...this.props
          };
          const attrs = element.attributes;
          for (let i = attrs.length - 1; i >= 0; i--) {
            props[attrs[i].name] = attrs[i].value;
          }
          const C = injectIntl(getComponent(component));
          if (C) {
            ReactDOM.render(/*#__PURE__*/React.createElement(Provider, {
              store: store
            }, /*#__PURE__*/React.createElement(IntlProvider, {
              locale: locale
            }, /*#__PURE__*/React.createElement(AppContextProvider, {
              getComponent: getComponent,
              store: store,
              locale: locale
            }, /*#__PURE__*/React.createElement(C, _extends({
              unique: (this.props.parentUnique ? this.props.parentUnique : '') + "_embeddable_" + index + "" + (Math.random() + 1).toString(36).substring(7)
            }, props, {
              childContent: element.innerHTML
            }))))), container);
          } else {
            ReactDOM.render(/*#__PURE__*/React.createElement("span", {
              style: {
                "color": "red"
              }
            }, component, " not found "), container);
          }
        }
      });
    }
  }
  componentDidMount() {
    this.renderEmbeddedComponents();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      parent
    } = this.props;
    if (parent != prevProps.parent) {
      this.renderEmbeddedComponents();
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.children);
  }
}
const WithContext = props => {
  return /*#__PURE__*/React.createElement(AppContext.Consumer, null, data => {
    if (data) {
      return /*#__PURE__*/React.createElement(EmbeddedGateway, _extends({}, props, {
        locale: data.locale,
        store: data.store,
        getComponent: data.getComponent
      }), props.children);
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, props.children, " ");
    }
  });
};
export default WithContext;